import clsx from 'clsx';
import moment from 'moment';
import React from 'react';

import SectionLoader from '@/src/components/common/Elements/Spinner/SectionLoader/SectionLoader';
import { DEFAULT_SYSTEM_USER } from '@/src/config';

import { ACTIVITIES_COMPONENTS } from './Activities.config';
import ActivityItemRow from './ActivityItemRow/ActivityItemRow';

export const evalDate = (date, includeDate = null) => {
  const isToday = moment().isSame(moment(date, 'MMMM DD, YYYY').format(), 'day');

  if (isToday) {
    return `Today${includeDate ? ', ' + moment(date, 'MMMM DD, YYYY').format('MMM D') : ''}`;
  } else {
    const isYesterday = moment()
      .add(-1, 'days')
      .isSame(moment(date, 'MMMM DD, YYYY').format(), 'day');
    if (isYesterday) {
      return `Yesterday${includeDate ? ', ' + moment(date, 'MMMM DD, YYYY').format('MMM D') : ''}`;
    } else {
      return date;
    }
  }
};

const Activities = (props) => {
  const {
    activityLogs,
    includeDate = false,
    isLoading = true,
    document,
    activityListHeight = 'tw-h-full',
  } = props;

  const renderActivityLogs = (log) => {
    return log.map((e) => {
      const { dateAdded, user, actionType } = e;
      const time = moment(dateAdded).format('h:mm a');
      const userLabel = user ? user.firstName + ' ' + user.lastName : DEFAULT_SYSTEM_USER;
      const activityLog = {
        ...e,
        time,
        document,
        documentFolder: e.document && e.document.document_folder,
        isDeleted: e.document && e.document.isDeleted,
      };
      const component = ACTIVITIES_COMPONENTS[actionType];

      return (
        <ActivityItemRow
          key={`air_${e.id}`}
          component={component}
          time={time}
          activityLog={activityLog}
          userLabel={userLabel}
        />
      );
    });
  };

  const customList = activityLogs
    .map((e) => {
      e.dateAdd = moment(e.dateAdded).format('MMMM DD, YYYY');
      return e;
    })
    .sort((a, b) => new Date(b.dateAdded).getTime() - new Date(a.dateAdded).getTime());

  // has linting error: The right-hand side of an arithmetic operation must be of type 'any', 'number', 'bigint' or an enum type
  // added getTime() to fix error
  // .sort((a, b) => new Date(b.dateAdded)- new Date(a.dateAdded));

  if (isLoading && customList.length > 0) {
    return <SectionLoader />;
  }

  const logObj = customList.reduce((acc, cur) => {
    (acc[cur.dateAdd] = acc[cur.dateAdd] || []).push(cur);
    return acc;
  }, {});
  const logKeys = Object.keys(logObj);

  return (
    <div className={clsx('tw-overflow-y-auto tw-scroll-styles', activityListHeight)}>
      {customList.length > 0 ? (
        <>
          {logKeys.map((log, index) => {
            return (
              <div key={index} className={clsx('activityItem', 'tw-mb-[20px]')}>
                <div
                  className={clsx(
                    'container--activityDate',
                    'tw-font-brandonTextMedium tw-text-cfo-black tw-mb-[15px]'
                  )}
                >
                  {evalDate(log, includeDate)}
                </div>
                {renderActivityLogs(logObj[log])}
              </div>
            );
          })}
        </>
      ) : !isLoading ? (
        <p className={clsx('tw-m-0 tw-p-0', 'tw-font-brandonTextMedium tw-text-cfo-black')}>
          No Activities Found
        </p>
      ) : null}
    </div>
  );
};

export default Activities;
